export enum SiteAvailabilityControl {
  SiteLevel = 'siteLevel',
  AssetLevel = 'assetLevel',
}
